import { ReactNode } from "react";
import { ROUTES } from "../components/consts/routes.consts";

export interface IMenuList {
  icon?: ReactNode;
  title?: string;
  route?: string;
}

export const navbarMenuConfig = [
  {
    title: "FAQ",
    route: ROUTES.FAQ,
  },
];
